import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../_services/index';


@Injectable()
export class ArtisanRouteGuard  {
  constructor(private router: Router,private authService: AuthService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.authService.isArtisan() || this.authService.isAdmin()) {
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url, infoBubble: "login-required" }});
        return false;
  }
}

// AG-2170: the consultation email opens the fiche AO with the company's pricing code, readable
// before the company signs up or logs in. Without that code the fiche keeps the artisan guard.
export const artisanProjectRouteGuard: CanActivateFn = (next, state) =>
  !!(next.queryParams['pricing'] && next.queryParams['code']) || inject(ArtisanRouteGuard).canActivate(next, state);
